export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateInterval: string;
  DateTime: string;
  DateTimeInterval: string;
  /** TODO: convert Duration into a Luxon object like DateTime or DateTimeInterval */
  Duration: any;
  IANAZone: string;
  /** ISO time string, without a date. e.g. 16:30 or 16:30:00 */
  Time: any;
  Upload: any;
  /** A completely null field, for types that are in a union but have no fields. */
  Void: any;
};

export type Attendee = {
  __typename: "Attendee";
  id: Scalars["ID"];
  isOptional?: Maybe<Scalars["Boolean"]>;
  isOrganizer?: Maybe<Scalars["Boolean"]>;
  person: Person;
  responseStatus?: Maybe<ResponseStatusEnum>;
};

export type AttendeeInput = {
  email: Scalars["String"];
  name: Scalars["String"];
  questionResponses: Array<QuestionResponseInput>;
};

export type AttendeeQuestion = {
  __typename: "AttendeeQuestion";
  id: Scalars["ID"];
  question: Scalars["String"];
  required: Scalars["Boolean"];
  type: AttendeeQuestionTypeEnum;
};

export type AttendeeQuestionInput = {
  question: Scalars["String"];
  required: Scalars["Boolean"];
  type: AttendeeQuestionTypeEnum;
};

export enum AttendeeQuestionTypeEnum {
  LongText = "LongText",
  PhoneNumber = "PhoneNumber",
  ShortText = "ShortText",
}

export type AvailabilityRange = FixedWindow | RollingWindow;

/**
 * The time range in which a booking can be made, should be specified with either `windowSize` or
 * `startDate` and `endDate`.
 */
export type AvailabilityRangeInput = {
  endDate?: InputMaybe<Scalars["Date"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  /** In days */
  windowSize?: InputMaybe<Scalars["Int"]>;
};

export enum AvailabilityRestrictionEnum {
  BalanceAvailabilityAndFocus = "BalanceAvailabilityAndFocus",
  MaximizeAvailability = "MaximizeAvailability",
  MaximizeFocusTime = "MaximizeFocusTime",
}

export type BillingGroup = {
  __typename: "BillingGroup";
  admins: Array<BillingGroupMember>;
  id: Scalars["ID"];
  linkLogoUrl?: Maybe<Scalars["String"]>;
  members: Array<BillingGroupMember>;
  name: Scalars["String"];
};

export type BillingGroupMember = {
  __typename: "BillingGroupMember";
  admin: Scalars["Boolean"];
  billingGroup: BillingGroup;
  id: Scalars["ID"];
  member: Member;
};

export enum BookableHoursEnum {
  CustomHours = "CustomHours",
  MeetingHours = "MeetingHours",
  WorkingHours = "WorkingHours",
}

export type BookingInput = {
  additionalAttendeeEmails?: InputMaybe<Array<Scalars["String"]>>;
  attendee: AttendeeInput;
  duration?: InputMaybe<Scalars["Int"]>;
  linkName: Scalars["ID"];
  slug: Scalars["String"];
  startTime: Scalars["DateTime"];
  timeZone: Scalars["IANAZone"];
};

export type BookingLimit = {
  __typename: "BookingLimit";
  count: Scalars["Int"];
  period: BookingLimitPeriodEnum;
};

export type BookingLimitInput = {
  count: Scalars["Int"];
  period: BookingLimitPeriodEnum;
};

export enum BookingLimitPeriodEnum {
  Daily = "Daily",
  Weekly = "Weekly",
}

/** Data about a single calendarId in our system */
export type Calendar = {
  __typename: "Calendar";
  displayName: Scalars["String"];
  eventsByWeek: Array<Event>;
  id: Scalars["ID"];
};

/** Data about a single calendarId in our system */
export type CalendarEventsByWeekArgs = {
  timeZone: Scalars["IANAZone"];
  weekStartDate: Scalars["Date"];
};

export type CalendarTimeStats = {
  __typename: "CalendarTimeStats";
  busyMinutes: Scalars["Int"];
  focusMinutes: Scalars["Int"];
  focusTimeGoal?: Maybe<Scalars["Int"]>;
  fragmentedMinutes: Scalars["Int"];
  id: Scalars["ID"];
  totalMinutes: Scalars["Int"];
  unclassifiedMinutes: Scalars["Int"];
};

export type CancelBookingInput = {
  id: Scalars["ID"];
  /** Reason for cancelation. */
  reason?: InputMaybe<Scalars["String"]>;
};

export type ClockwiseSubscription = {
  __typename: "ClockwiseSubscription";
  id: Scalars["ID"];
  productType: ProductType;
  type: SubscriptionType;
};

export type Conferencing = {
  __typename: "Conferencing";
  type: ConferencingType;
  url: Scalars["String"];
};

export enum ConferencingType {
  Meet = "MEET",
  Other = "OTHER",
  TeamsForBusiness = "TEAMS_FOR_BUSINESS",
  Zoom = "ZOOM",
}

export type CreateSchedulingLinkFromDraftEventInput = {
  eventDiffId: Scalars["String"];
};

/** Represents available hours for a specific date (e.g, 12pm—3pm on 2024-03-11) */
export type CustomAvailabilityByDate = {
  __typename: "CustomAvailabilityByDate";
  date: Scalars["Date"];
  timeRanges: Array<CustomAvailabilityTimeRange>;
};

/** Represents available hours for a specific date (e.g, 12pm—3pm on 2024-03-11) */
export type CustomAvailabilityByDateInput = {
  date: Scalars["Date"];
  timeRanges: Array<CustomAvailabilityTimeRangeInput>;
};

/** Represents available hours for a given day of the week (e.g., 9am—5pm on Mondays) */
export type CustomAvailabilityByDay = {
  __typename: "CustomAvailabilityByDay";
  day: DayEnum;
  timeRanges: Array<CustomAvailabilityTimeRange>;
};

/** Represents available hours for a given day of the week (e.g., 9am—5pm on Mondays) */
export type CustomAvailabilityByDayInput = {
  day: DayEnum;
  timeRanges: Array<CustomAvailabilityTimeRangeInput>;
};

export type CustomAvailabilityTimeRange = {
  __typename: "CustomAvailabilityTimeRange";
  endTime: Scalars["String"];
  startTime: Scalars["String"];
};

export type CustomAvailabilityTimeRangeInput = {
  endTime: Scalars["String"];
  startTime: Scalars["String"];
};

export type CustomMeetingHours = {
  __typename: "CustomMeetingHours";
  dateOverrides: Array<CustomAvailabilityByDate>;
  schedule: Array<CustomAvailabilityByDay>;
};

export type CustomMeetingHoursInput = {
  dateOverrides: Array<CustomAvailabilityByDateInput>;
  schedule: Array<CustomAvailabilityByDayInput>;
};

export type DateOrTimeRange = DateRange | DateTimeRange;

/** A ISO8601 date range, unzoned, with no time component. (e.g. 2024-05-01/2024-05-31) */
export type DateRange = {
  __typename: "DateRange";
  range: Scalars["DateInterval"];
};

/** An ISO8601 time range with a start and end time. (e.g. 2024-05-01T16:30:00Z/2024-05-31T17:30:00Z) */
export type DateTimeRange = {
  __typename: "DateTimeRange";
  range: Scalars["DateTimeInterval"];
};

export enum DayEnum {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type DayFlexibility = SpecificWorkdays | WithinDay | WithinWeek;

export enum DayOfWeek {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type Event = EventInterface & {
  __typename: "Event";
  areAttendeesOmitted: Scalars["Boolean"];
  attendees: Array<Attendee>;
  calendarId: Scalars["ID"];
  canMarkFlexible: Scalars["Boolean"];
  canReschedule: Scalars["Boolean"];
  category: EventCategory;
  conferencing?: Maybe<Conferencing>;
  dateOrTimeRange: DateOrTimeRange;
  description?: Maybe<Scalars["String"]>;
  eventPermissions: EventPermissions;
  externalEventId: Scalars["ID"];
  flexibility?: Maybe<FlexDetails>;
  history: EventLog;
  id: Scalars["ID"];
  isAllDay: Scalars["Boolean"];
  isCanceled: Scalars["Boolean"];
  /** Determines if the event can be collapsed in the UI. */
  isCollapsible: Scalars["Boolean"];
  isDescriptionOmitted: Scalars["Boolean"];
  isHold: Scalars["Boolean"];
  isLocked: Scalars["Boolean"];
  isMarkedBusy: Scalars["Boolean"];
  location?: Maybe<Scalars["String"]>;
  organizer?: Maybe<Attendee>;
  recurrence?: Maybe<Recurrence>;
  /** Response status of the current user, if on their own calendar, `NotApplicable` otherwise */
  responseStatus: ResponseStatusEnum;
  rooms: Array<Maybe<Room>>;
  /** Human readable description of the event time & recurrence, including flexibility if applicable. */
  timeDescription: Scalars["String"];
  title: Scalars["String"];
};

export type EventCategory = {
  __typename: "EventCategory";
  /** Number assingments for Google VS Outlook (vs future calendars?). UI Hex values defined in client */
  color?: Maybe<Scalars["String"]>;
  type: EventCategoryType;
};

export enum EventCategoryType {
  AdHoc = "AdHoc",
  External = "External",
  FocusTime = "FocusTime",
  Holiday = "Holiday",
  IndividualHold = "IndividualHold",
  OneOnOne = "OneOnOne",
  Other = "Other",
  OutOfOffice = "OutOfOffice",
  PaceSetting = "PaceSetting",
}

export type EventInterface = {
  areAttendeesOmitted: Scalars["Boolean"];
  attendees: Array<Attendee>;
  calendarId: Scalars["ID"];
  dateOrTimeRange: DateOrTimeRange;
  externalEventId: Scalars["ID"];
  flexibility?: Maybe<FlexDetails>;
  id: Scalars["ID"];
  isAllDay: Scalars["Boolean"];
  organizer?: Maybe<Attendee>;
};

export type EventLog = {
  __typename: "EventLog";
  entries: Array<EventLogEntry>;
  status: EventLogStatus;
};

export type EventLogEntry = {
  __typename: "EventLogEntry";
  details: Array<Scalars["String"]>;
  timestamp: Scalars["DateTime"];
  title: Scalars["String"];
  type: EventLogType;
};

export enum EventLogStatus {
  Incomplete = "Incomplete",
  NotVisible = "NotVisible",
  Off = "Off",
  On = "On",
}

export enum EventLogType {
  ClockwiseCouldNotResolveConflict = "ClockwiseCouldNotResolveConflict",
  ClockwiseMeetingMove = "ClockwiseMeetingMove",
  ClockwiseMovePaused = "ClockwiseMovePaused",
  ClockwiseMoveUnpaused = "ClockwiseMoveUnpaused",
  EventCreated = "EventCreated",
  EventRescheduled = "EventRescheduled",
  FlexTurnedOff = "FlexTurnedOff",
  FlexTurnedOn = "FlexTurnedOn",
  NextFlexRun = "NextFlexRun",
}

/** What the current user can do with an event */
export type EventPermissions = {
  __typename: "EventPermissions";
  canDelete: Scalars["Boolean"];
  canInviteOthers: Scalars["Boolean"];
  canModify: Scalars["Boolean"];
  canRSVP: Scalars["Boolean"];
  canSeeOtherGuests: Scalars["Boolean"];
};

export enum EventRole {
  Attendee = "Attendee",
  Editor = "Editor",
  Inviter = "Inviter",
  Owner = "Owner",
  Reader = "Reader",
}

export type FixedWindow = {
  __typename: "FixedWindow";
  endDate: Scalars["Date"];
  startDate: Scalars["Date"];
};

export type FlexDetails = {
  __typename: "FlexDetails";
  isFlexible: Scalars["Boolean"];
  status: FlexStatus;
  timeOfDayFlexRange?: Maybe<TimeRange>;
};

export enum FlexStatus {
  CanMove = "CanMove",
  EventExceedsDefragRange = "EventExceedsDefragRange",
  EventOutsideTimeRange = "EventOutsideTimeRange",
  External = "External",
  NoDuration = "NoDuration",
  OverQuota = "OverQuota",
  Paused = "Paused",
  Pinned = "Pinned",
  PrivateEvent = "PrivateEvent",
  SmartHold = "SmartHold",
  TrialExpired = "TrialExpired",
}

export type FlexibleMeetingsDashboard = {
  __typename: "FlexibleMeetingsDashboard";
  flexibleMeetings: Array<Event>;
  holds: Array<Event>;
  oneOnOneAverage: Scalars["Int"];
  oneOnOnes: Array<Event>;
  recurringMeetings: Array<Event>;
  suggestedFlexibleMeetings: Array<Event>;
};

export enum GroupSchedulingStrategyEnum {
  RoundRobinMaxAvailability = "RoundRobinMaxAvailability",
}

export enum HistoryStatus {
  Incomplete = "Incomplete",
  NotVisible = "NotVisible",
  Off = "Off",
  On = "On",
}

export type HomeAnalytics = {
  __typename: "HomeAnalytics";
  currentWeek?: Maybe<WeekAnalytics>;
  previousWeek?: Maybe<WeekAnalytics>;
};

export type LinkBooking = {
  __typename: "LinkBooking";
  attendees: Array<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  duration: Scalars["Int"];
  id: Scalars["ID"];
  /** Link times that are aware of the current booking and show that time range as bookable. */
  linkTimes: Array<SuggestedSlot>;
  location?: Maybe<LocationTypeEnum>;
  name: Scalars["String"];
  owner: Person;
  publicSchedulingLink?: Maybe<PublicSchedulingLink>;
  timeSlot: Scalars["DateTimeInterval"];
};

export type LinkBookingLinkTimesArgs = {
  duration?: InputMaybe<Scalars["Int"]>;
  endDate: Scalars["Date"];
  startDate: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type LinkMember = {
  __typename: "LinkMember";
  id: Scalars["ID"];
  member: Member;
  owner: Scalars["Boolean"];
  required: Scalars["Boolean"];
  roundRobinEnabled: Scalars["Boolean"];
  schedulingPriority?: Maybe<SchedulingPriorityEnum>;
};

export type LinkMemberInput = {
  memberId: Scalars["ID"];
  owner: Scalars["Boolean"];
  required: Scalars["Boolean"];
  schedulingPriority?: InputMaybe<SchedulingPriorityEnum>;
};

export enum LocationTypeEnum {
  /** No videoconferencing, just information in the description */
  InDescription = "InDescription",
  /** Google Meet */
  Meet = "Meet",
  /** Microsoft Teams */
  Teams = "Teams",
  Zoom = "Zoom",
}

export enum MeetingReliefSettingVisibility {
  DisabledByPaywall = "DisabledByPaywall",
  HideSetting = "HideSetting",
  ShowWithBadge = "ShowWithBadge",
  ShowWithoutBadge = "ShowWithoutBadge",
}

/** A member of an organization that is using Clockwise */
export type Member = {
  __typename: "Member";
  calendarTimeStats?: Maybe<CalendarTimeStats>;
  /** External user id */
  id: Scalars["ID"];
  person: Person;
  roundRobinEnabled: Scalars["Boolean"];
  user?: Maybe<User>;
};

/** A member of an organization that is using Clockwise */
export type MemberCalendarTimeStatsArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type MemberConnection = {
  __typename: "MemberConnection";
  edges: Array<MemberEdge>;
  pageInfo: PageInfo;
};

export type MemberEdge = {
  __typename: "MemberEdge";
  cursor: Scalars["String"];
  node: Member;
};

export type Mutation = {
  __typename: "Mutation";
  cancelBooking?: Maybe<Scalars["Boolean"]>;
  checkLinkNameAvailable?: Maybe<Scalars["Boolean"]>;
  /** Create a new booking for a Scheduling Link */
  createBooking?: Maybe<LinkBooking>;
  /** Create a default starting linkName for the current user, if they don't have one yet. */
  createDefaultLinkName?: Maybe<User>;
  createSchedulingLink: SchedulingLink;
  createSchedulingLinkFromDraftEvent: SchedulingLinkWithUrl;
  deleteCustomLinkLogo: User;
  deleteLinkLogoForBillingGroup: BillingGroup;
  deleteSchedulingLink?: Maybe<Scalars["Boolean"]>;
  rescheduleBooking?: Maybe<Scalars["Boolean"]>;
  /** Reschedules an event to the new specified time. */
  rescheduleEvent?: Maybe<Event>;
  saveLinkSignInWaitlist?: Maybe<Scalars["Boolean"]>;
  saveName: Scalars["String"];
  /** Performs a complete replacement/insertion of a set of contextual string for AI to remember. */
  updateAIMemory: Array<Scalars["String"]>;
  /** Update the user's response for a specific event. */
  updateEventResponse?: Maybe<Event>;
  updateLinkActive?: Maybe<SchedulingLink>;
  updateLinkName?: Maybe<User>;
  /** Update whether Clockwise should auto-reply to meeting requests on no-meeting days. */
  updateNoMeetingAutoreplyEnabled?: Maybe<Team>;
  /** Updates the specific day of the week that is the no-meeting day for a team. */
  updateNoMeetingDay?: Maybe<Team>;
  /** Updates whether no-meeting day is enabled for a team. */
  updateNoMeetingDayEnabled?: Maybe<Team>;
  updateSchedulingLink: SchedulingLink;
  uploadCustomLinkLogo?: Maybe<User>;
  uploadLinkLogoForBillingGroup?: Maybe<BillingGroup>;
};

export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};

export type MutationCheckLinkNameAvailableArgs = {
  linkName: Scalars["String"];
};

export type MutationCreateBookingArgs = {
  input: BookingInput;
};

export type MutationCreateSchedulingLinkArgs = {
  input: SchedulingLinkInput;
};

export type MutationCreateSchedulingLinkFromDraftEventArgs = {
  input: CreateSchedulingLinkFromDraftEventInput;
};

export type MutationDeleteLinkLogoForBillingGroupArgs = {
  billingGroupId: Scalars["ID"];
};

export type MutationDeleteSchedulingLinkArgs = {
  id: Scalars["ID"];
};

export type MutationRescheduleBookingArgs = {
  input: RescheduleBookingInput;
};

export type MutationRescheduleEventArgs = {
  input: RescheduleEventInput;
};

export type MutationSaveLinkSignInWaitlistArgs = {
  input: SaveLinkSignInWaitlistInput;
};

export type MutationSaveNameArgs = {
  firstName: Scalars["String"];
};

export type MutationUpdateAiMemoryArgs = {
  input: Array<Scalars["String"]>;
};

export type MutationUpdateEventResponseArgs = {
  input: UpdateEventResponseInput;
};

export type MutationUpdateLinkActiveArgs = {
  input: UpdateLinkActiveInput;
};

export type MutationUpdateLinkNameArgs = {
  linkName: Scalars["String"];
};

export type MutationUpdateNoMeetingAutoreplyEnabledArgs = {
  enabled: Scalars["Boolean"];
  teamId: Scalars["ID"];
};

export type MutationUpdateNoMeetingDayArgs = {
  day: DayEnum;
  teamId: Scalars["ID"];
};

export type MutationUpdateNoMeetingDayEnabledArgs = {
  enabled: Scalars["Boolean"];
  teamId: Scalars["ID"];
};

export type MutationUpdateSchedulingLinkArgs = {
  input: UpdateSchedulingLinkInput;
};

export type MutationUploadCustomLinkLogoArgs = {
  input: UploadCustomLinkLogoInput;
};

export type MutationUploadLinkLogoForBillingGroupArgs = {
  input: UploadLinkLogoForBillingGroupInput;
};

export type NoMeetingDayOptions = {
  __typename: "NoMeetingDayOptions";
  autoreplyEnabled: Scalars["Boolean"];
  day?: Maybe<DayEnum>;
  enabled: Scalars["Boolean"];
};

export type OnboardingChecklist = {
  __typename: "OnboardingChecklist";
  flexMeetingEnabled: Scalars["Boolean"];
  focusTimeEnabled: Scalars["Boolean"];
};

export type Org = {
  __typename: "Org";
  billingGroups: Array<BillingGroup>;
  id: Scalars["ID"];
  name: Scalars["String"];
  zoomAccount?: Maybe<ZoomAccount>;
};

/** Page metadata for paginated queries */
export type PageInfo = {
  __typename: "PageInfo";
  endCursor?: Maybe<Scalars["String"]>;
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  startCursor?: Maybe<Scalars["String"]>;
};

export type PaidFeatureState = {
  __typename: "PaidFeatureState";
  autopilotWhenOrganizerCurrentlyAllowed: Scalars["Boolean"];
  brandedLinksForBillingGroupsAllowed: Scalars["Boolean"];
  eligibleForNoMeetingDay: Scalars["Boolean"];
  eligibleForTeamCalendarVisibility: Scalars["Boolean"];
  focusTimeAllowed: Scalars["Boolean"];
  meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
  moveRangesEnabled: Scalars["Boolean"];
  paymentStatus?: Maybe<PaymentStatus>;
  primaryBillingGroup?: Maybe<BillingGroup>;
  roundRobinEnabled: Scalars["Boolean"];
  subscription?: Maybe<ClockwiseSubscription>;
  trialMetadata?: Maybe<TrialMetadata>;
};

export enum PaymentStatus {
  Business = "Business",
  Enterprise = "Enterprise",
  Free = "Free",
  Pro = "Pro",
  Trial = "Trial",
}

export type Person = Profile & {
  __typename: "Person";
  displayName: Scalars["String"];
  email: Scalars["String"];
  externalImageUrl?: Maybe<Scalars["String"]>;
  familyName?: Maybe<Scalars["String"]>;
  givenName?: Maybe<Scalars["String"]>;
  /** Lowercase email as id. Not to be confused with calendar id. */
  id: Scalars["ID"];
};

export type PersonalizedStatsRow = {
  __typename: "PersonalizedStatsRow";
  homeAnalytics: HomeAnalytics;
  id: Scalars["ID"];
  onboardingChecklist: OnboardingChecklist;
};

export enum ProductType {
  BusinessNonStandard = "Business_NonStandard",
  BusinessStandard = "Business_Standard",
  EnterpriseNonStandard = "Enterprise_NonStandard",
  EnterpriseStandard = "Enterprise_Standard",
  ProNonStandard = "Pro_NonStandard",
  ProStandard = "Pro_Standard",
}

export type Profile = {
  displayName: Scalars["String"];
  email: Scalars["String"];
  externalImageUrl?: Maybe<Scalars["String"]>;
  familyName?: Maybe<Scalars["String"]>;
  givenName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type PublicLinkMember = {
  __typename: "PublicLinkMember";
  id: Scalars["ID"];
  owner: Scalars["Boolean"];
  person: Person;
  required: Scalars["Boolean"];
  schedulingPriority?: Maybe<SchedulingPriorityEnum>;
};

export type PublicSchedulingLink = {
  __typename: "PublicSchedulingLink";
  allowAdditionalAttendees: Scalars["Boolean"];
  attendeeQuestions: Array<AttendeeQuestion>;
  bufferHours: Scalars["Int"];
  defaultDuration: Scalars["Int"];
  description?: Maybe<Scalars["String"]>;
  durations: Array<Scalars["Int"]>;
  endOfAvailability: Scalars["DateTime"];
  groupSchedulingStrategy?: Maybe<GroupSchedulingStrategyEnum>;
  highlightBestTimes: Scalars["Boolean"];
  id: Scalars["ID"];
  linkLogoUrl?: Maybe<Scalars["String"]>;
  linkMembers: Array<PublicLinkMember>;
  linkName: Scalars["String"];
  linkTimes: Array<SuggestedSlot>;
  location?: Maybe<LocationTypeEnum>;
  managedByMe: Scalars["Boolean"];
  maxBookings?: Maybe<BookingLimit>;
  name: Scalars["String"];
  ownedByMe: Scalars["Boolean"];
  slug: Scalars["String"];
};

export type PublicSchedulingLinkLinkTimesArgs = {
  duration?: InputMaybe<Scalars["Int"]>;
  endDate: Scalars["Date"];
  startDate: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type Query = {
  __typename: "Query";
  /**
   * Fetches the set of strings a user has instructed the AI to remember for requests.
   * e.g. "My boss's name is Andy."
   */
  aiMemory: Array<Scalars["String"]>;
  calendar?: Maybe<Calendar>;
  calendars: Array<Maybe<Calendar>>;
  currentName: Scalars["String"];
  currentOrg?: Maybe<Org>;
  currentUser?: Maybe<User>;
  /** Fetches an event by externalEventId */
  event?: Maybe<Event>;
  /** Fetch multiple events by externalEventId */
  events: Array<Maybe<Event>>;
  eventsByDates: Array<Maybe<Event>>;
  flexibleMeetingsDashboard: FlexibleMeetingsDashboard;
  hello: Scalars["String"];
  intentionallyError?: Maybe<Scalars["Boolean"]>;
  linkBooking?: Maybe<LinkBooking>;
  members: Array<Maybe<Member>>;
  paidFeatures?: Maybe<PaidFeatureState>;
  personalizedStatsRow?: Maybe<PersonalizedStatsRow>;
  /** Fetches a public scheduling link for creating a booking, accessible anonymously */
  publicSchedulingLink?: Maybe<PublicSchedulingLink>;
  rescheduleOptions: RescheduleOptions;
  searchMembers: MemberConnection;
  team?: Maybe<Team>;
  testDate: Scalars["Date"];
  testDateTime: Scalars["DateTime"];
  testInterval: Scalars["DateTimeInterval"];
};

export type QueryCalendarArgs = {
  id: Scalars["ID"];
};

export type QueryCalendarsArgs = {
  ids: Array<Scalars["ID"]>;
};

export type QueryEventArgs = {
  calendarId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
};

export type QueryEventsArgs = {
  calendarId?: InputMaybe<Scalars["ID"]>;
  ids: Array<Scalars["ID"]>;
};

export type QueryEventsByDatesArgs = {
  calendarId?: InputMaybe<Scalars["ID"]>;
  end: Scalars["Date"];
  start: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type QueryLinkBookingArgs = {
  id: Scalars["ID"];
};

export type QueryMembersArgs = {
  calendarIds: Array<Scalars["ID"]>;
};

export type QueryPublicSchedulingLinkArgs = {
  linkName: Scalars["ID"];
  slug: Scalars["ID"];
};

export type QueryRescheduleOptionsArgs = {
  externalEventId: Scalars["ID"];
};

export type QuerySearchMembersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  query: Scalars["String"];
};

export type QueryTeamArgs = {
  id: Scalars["ID"];
};

export type QueryTestDateArgs = {
  date: Scalars["Date"];
};

export type QueryTestDateTimeArgs = {
  date: Scalars["DateTime"];
};

export type QueryTestIntervalArgs = {
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
};

export type QuestionResponseInput = {
  question: Scalars["String"];
  response: Scalars["String"];
};

export type Recurrence = {
  __typename: "Recurrence";
  description?: Maybe<Scalars["String"]>;
  type: RecurrenceType;
};

/**
 * A simplification of recurrence; we classify a recurrence by the frequency which is _greater or equal_ its actual frequency.
 *
 * examples
 * | Event             | RecurrenceType  |
 * | ----------------- | --------------- |
 * | every day         | Daily           |
 * | twice a week      | Weekly          |
 * | every other week  | Fortnightly     |
 * | every third week  | Monthly         |
 * | once a year       | LessThanMonthly |
 */
export enum RecurrenceType {
  Daily = "Daily",
  Fortnightly = "Fortnightly",
  LessThanMonthly = "LessThanMonthly",
  Monthly = "Monthly",
  Weekly = "Weekly",
}

export type RescheduleBookingInput = {
  id: Scalars["ID"];
  reason?: InputMaybe<Scalars["String"]>;
  timeRange: Scalars["DateTimeInterval"];
};

export type RescheduleEventInput = {
  externalEventId: Scalars["ID"];
  startTime: Scalars["DateTime"];
  timeZone: Scalars["IANAZone"];
};

export type RescheduleOptions = {
  __typename: "RescheduleOptions";
  rescheduleOptions: Array<SchedulingOption>;
};

export enum ResponseStatusEnum {
  Accepted = "Accepted",
  Declined = "Declined",
  NeedsAction = "NeedsAction",
  NotApplicable = "NotApplicable",
  Tentative = "Tentative",
}

export type RollingWindow = {
  __typename: "RollingWindow";
  windowSize?: Maybe<Scalars["Int"]>;
};

export type Room = {
  __typename: "Room";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type SaveLinkSignInWaitlistInput = {
  anonymousId: Scalars["String"];
  email: Scalars["String"];
  linkName: Scalars["String"];
  slug: Scalars["String"];
};

export type SchedulingLink = {
  __typename: "SchedulingLink";
  active: Scalars["Boolean"];
  allowAdditionalAttendees: Scalars["Boolean"];
  allowBookingOnNoMeetingDay: Scalars["Boolean"];
  allowQuarterHourBooking: Scalars["Boolean"];
  attendeeQuestions: Array<AttendeeQuestion>;
  availabilityRange: AvailabilityRange;
  availabilityRestriction: AvailabilityRestrictionEnum;
  bookableHours: BookableHoursEnum;
  bufferHours: Scalars["Int"];
  customMeetingHours?: Maybe<CustomMeetingHours>;
  defaultDuration: Scalars["Int"];
  description?: Maybe<Scalars["String"]>;
  durations: Array<Scalars["Int"]>;
  groupSchedulingStrategy?: Maybe<GroupSchedulingStrategyEnum>;
  highlightBestTimes: Scalars["Boolean"];
  id: Scalars["ID"];
  linkMembers: Array<LinkMember>;
  linkTimes: Array<SuggestedSlot>;
  location: LocationTypeEnum;
  maxBookings?: Maybe<BookingLimit>;
  name: Scalars["String"];
  owner: Member;
  singleUse: Scalars["Boolean"];
  slug: Scalars["String"];
  textOnlyTitle: Scalars["Boolean"];
  titleTemplate: Scalars["String"];
};

export type SchedulingLinkLinkTimesArgs = {
  duration?: InputMaybe<Scalars["Int"]>;
  endDate: Scalars["Date"];
  linkName: Scalars["String"];
  startDate: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type SchedulingLinkInput = {
  active: Scalars["Boolean"];
  allowAdditionalAttendees: Scalars["Boolean"];
  allowBookingOnNoMeetingDay: Scalars["Boolean"];
  allowQuarterHourBooking: Scalars["Boolean"];
  attendeeQuestions: Array<AttendeeQuestionInput>;
  availabilityRange: AvailabilityRangeInput;
  availabilityRestriction: AvailabilityRestrictionEnum;
  bookableHours: BookableHoursEnum;
  bufferHours: Scalars["Int"];
  customMeetingHours?: InputMaybe<CustomMeetingHoursInput>;
  defaultDuration: Scalars["Int"];
  description?: InputMaybe<Scalars["String"]>;
  durations: Array<Scalars["Int"]>;
  groupSchedulingStrategy?: InputMaybe<GroupSchedulingStrategyEnum>;
  highlightBestTimes: Scalars["Boolean"];
  linkMembers: Array<LinkMemberInput>;
  location?: InputMaybe<LocationTypeEnum>;
  maxBookings?: InputMaybe<BookingLimitInput>;
  name: Scalars["String"];
  /** Whether this link can only be used for a single booking. */
  singleUse: Scalars["Boolean"];
  slug: Scalars["String"];
  textOnlyTitle: Scalars["Boolean"];
  titleTemplate: Scalars["String"];
};

export type SchedulingLinkWithUrl = {
  __typename: "SchedulingLinkWithUrl";
  id: Scalars["ID"];
  /**
   * The linkName that must be used to fetch details about this link.
   * May be different than the linkName of the user loading the link when the user is a member of a group link.
   * For example, I may be a member of the group link, but the creator of the group link may have a different linkName.
   * In this case, the creators linkName must be used. In short, always use the linkName returned by the BE and
   * not the linkName off of the user object.
   */
  linkName: Scalars["String"];
  schedulingLink: SchedulingLink;
  url: Scalars["String"];
};

export type SchedulingOption = {
  __typename: "SchedulingOption";
  start: Scalars["DateTime"];
};

export enum SchedulingPriorityEnum {
  DoNotSchedule = "DoNotSchedule",
  High = "High",
  Low = "Low",
  Medium = "Medium",
}

export enum SmartHoldState {
  Paused = "Paused",
  Protected = "Protected",
  Unpaused = "Unpaused",
}

export type SpecificWorkdays = {
  __typename: "SpecificWorkdays";
  days: Array<DayOfWeek>;
};

export enum SubscriptionType {
  Expired = "Expired",
  FreemiumOrg = "FreemiumOrg",
  LegacyPrePaywall = "LegacyPrePaywall",
  PaidBillingGroup = "PaidBillingGroup",
  PaidOrgPro = "PaidOrgPro",
  PaidTeamPro = "PaidTeamPro",
  PaidUserPro = "PaidUserPro",
  SelfServePremiumOrgQ42020 = "SelfServePremiumOrgQ42020",
  SelfServePremiumTeamQ12021 = "SelfServePremiumTeamQ12021",
}

export type SuggestedSlot = {
  __typename: "SuggestedSlot";
  id: Scalars["ID"];
  tag?: Maybe<SuggestedSlotTagEnum>;
  timeSlot: Scalars["DateTimeInterval"];
};

export enum SuggestedSlotTagEnum {
  Best = "Best",
  Inconvenient = "Inconvenient",
}

export type Team = {
  __typename: "Team";
  calendarId?: Maybe<Scalars["ID"]>;
  disruptiveEvents: Array<Event>;
  id: Scalars["ID"];
  members: Array<TeamMember>;
  name: Scalars["String"];
  noMeetingDay: NoMeetingDayOptions;
};

export type TeamDisruptiveEventsArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  timeZone: Scalars["IANAZone"];
};

export type TeamMember = {
  __typename: "TeamMember";
  admin: Scalars["Boolean"];
  id: Scalars["ID"];
  member?: Maybe<Member>;
  status: TeamMemberStatus;
};

export enum TeamMemberStatus {
  Active = "Active",
  Invited = "Invited",
}

export type TestBar = {
  __typename: "TestBar";
  actor: TestEntity;
  definitelyFruit: TestFruit;
  definitelyStr: Scalars["String"];
  id: Scalars["ID"];
  maybeActor?: Maybe<TestEntity>;
  maybeFruit?: Maybe<TestFruit>;
  maybeStr?: Maybe<Scalars["String"]>;
};

export type TestEntity = TestHuman | TestRobot;

export type TestFoo = {
  __typename: "TestFoo";
  actor: TestEntity;
  definitelyFruit: TestFruit;
  definitelyStr: Scalars["String"];
  id: Scalars["ID"];
  maybeActor?: Maybe<TestEntity>;
  maybeFruit?: Maybe<TestFruit>;
  maybeStr?: Maybe<Scalars["String"]>;
};

export enum TestFruit {
  Apple = "APPLE",
  Banana = "BANANA",
  Cherry = "CHERRY",
}

export type TestHuman = {
  __typename: "TestHuman";
  birthDate: Scalars["String"];
  name: Scalars["String"];
};

export type TestRobot = {
  __typename: "TestRobot";
  createdOn: Scalars["String"];
  name: Scalars["String"];
};

/** A range of times within a day, potentially unbounded when start or end is null. */
export type TimeRange = {
  __typename: "TimeRange";
  end?: Maybe<Scalars["Time"]>;
  start?: Maybe<Scalars["Time"]>;
};

export type TrialMetadata = {
  __typename: "TrialMetadata";
  isTrialExpired: Scalars["Boolean"];
  timeZone: Scalars["IANAZone"];
  trialEndDate: Scalars["Date"];
};

export type UpdateEventResponseInput = {
  externalEventId: Scalars["ID"];
  responseStatus: ResponseStatusEnum;
};

export type UpdateLinkActiveInput = {
  active: Scalars["Boolean"];
  linkName: Scalars["String"];
  slug: Scalars["ID"];
};

export type UpdateSchedulingLinkInput = {
  id: Scalars["ID"];
  schedulingLink: SchedulingLinkInput;
};

export type UploadCustomLinkLogoInput = {
  logoImage: Scalars["Upload"];
};

export type UploadLinkLogoForBillingGroupInput = {
  billingGroupId: Scalars["ID"];
  logoImage: Scalars["Upload"];
};

/** A Clockwise user. */
export type User = {
  __typename: "User";
  /** User id */
  id: Scalars["ID"];
  linkLogoUrl?: Maybe<Scalars["String"]>;
  linkName?: Maybe<Scalars["String"]>;
  member: Member;
  resolvedLinkLogoUrl?: Maybe<Scalars["String"]>;
  schedulingLink?: Maybe<SchedulingLink>;
  schedulingLinks: Array<SchedulingLinkWithUrl>;
  zoomAccount?: Maybe<ZoomAccount>;
};

/** A Clockwise user. */
export type UserSchedulingLinkArgs = {
  linkName?: InputMaybe<Scalars["String"]>;
  slug: Scalars["ID"];
};

/** A Clockwise user. */
export type UserSchedulingLinksArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type UserProfileInput = {
  externalImageUrl?: InputMaybe<Scalars["String"]>;
  familyName: Scalars["String"];
  givenName: Scalars["String"];
  id: Scalars["ID"];
};

export type WeekAnalytics = {
  __typename: "WeekAnalytics";
  conflictsResolved: Scalars["Int"];
  focusTimeHeld: Scalars["Duration"];
  meetingTime: Scalars["Duration"];
};

export type WithinDay = {
  __typename: "WithinDay";
  void?: Maybe<Scalars["Void"]>;
};

export type WithinWeek = {
  __typename: "WithinWeek";
  void?: Maybe<Scalars["Void"]>;
};

export type ZoomAccount = {
  __typename: "ZoomAccount";
  displayName: Scalars["String"];
  id: Scalars["ID"];
  owner: User;
  valid: Scalars["Boolean"];
};
